/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGroupOrderRequest
 */
export interface UpdateGroupOrderRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGroupOrderRequest
     */
    sessionIds?: Array<string> | null;
}

/**
 * Check if a given object implements the UpdateGroupOrderRequest interface.
 */
export function instanceOfUpdateGroupOrderRequest(value: object): value is UpdateGroupOrderRequest {
    return true;
}

export function UpdateGroupOrderRequestFromJSON(json: any): UpdateGroupOrderRequest {
    return UpdateGroupOrderRequestFromJSONTyped(json, false);
}

export function UpdateGroupOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGroupOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionIds': json['sessionIds'] == null ? undefined : json['sessionIds'],
    };
}

export function UpdateGroupOrderRequestToJSON(json: any): UpdateGroupOrderRequest {
    return UpdateGroupOrderRequestToJSONTyped(json, false);
}

export function UpdateGroupOrderRequestToJSONTyped(value?: UpdateGroupOrderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionIds': value['sessionIds'],
    };
}

